import React from "react";
import { Dialog } from "material-ui";

import connectToStores from "alt-utils/lib/connectToStores";
import VenueActions from "../actions/VenueActions";
import VenueStore from "../stores/VenueStore";

const SEATS_IO_SCRIPT_URL = "https://cdn.seatsio.net/chart.js";

class VenueSeatmapEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      renderedChartId: null,
      editorInstance: null
    };

    this.close = this.close.bind(this);
    this.createInstance = this.createInstance.bind(this);
    this.destroyInstance = this.destroyInstance.bind(this);
  }

  static getStores() {
    return [VenueStore];
  }

  static getPropsFromStores() {
    return {
      getVenueById: VenueStore.getVenueById
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  close() {
    this.context.router.goBack();
  }

  createInstance() {
    let venue = this.props.getVenueById(this.props.params.venueId);

    if (!window.seatsio || !venue) {
      return;
    }

    if (
      this.state.editorInstance &&
      this.state.renderedChartId === venue.seatmap_id
    ) {
      // Already rendered chart
      return;
    } else if (this.state.editorInstance) {
      // This means new chart, time to destroy old before creating new
      this.destroyInstance();
    }

    let instance = new window.seatsio.SeatingChartDesigner({
      divId: "seatioInject",
      designerKey: process.env.SEATS_IO_DESIGNER_KEY,
      chartKey: venue.seatmap_id,
      features: {
        disabled: ["backgroundImage"],
        readOnly: ["chartName"]
      },
      baseColor: "#0288d1",
      onChartCreated: key => {
        VenueActions.edit(this.props.params.venueId, {
          seatmap_id: key
        });
      },
      onExitRequested: () => {
        this.close();
      }
    });

    this.setState({
      renderedChartId: venue.seatmap_id,
      editorInstance: instance
    });

    instance.render();
  }

  destroyInstance() {
    document.getElementById("seatioInject").innerHTML = "";
    window.seatsio.removeFromArray(
      this.state.editorInstance,
      window.seatsio.charts
    );
  }

  componentDidMount() {
    if (!document.querySelector(`script[src="${SEATS_IO_SCRIPT_URL}"]`)) {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = SEATS_IO_SCRIPT_URL;
      script.onload = this.createInstance;
      document.body.appendChild(script);
    }

    // If we already have a seatmap id on first load, go ahead and create the instance
    this.componentWillReceiveProps();
  }

  componentWillReceiveProps(props) {
    let venue = this.props.getVenueById(this.props.params.venueId);
    if (venue) {
      this.createInstance();
    }
  }

  componentWillUnmount() {
    if (this.state.editorInstance) {
      // dispatch edit action to force refresh
      VenueActions.edit.defer(this.props.params.venueId, {});
      this.destroyInstance();
    }
  }

  getStyles() {
    return {
      dialog: {
        width: "95%",
        maxWidth: "none",
        overflow: "hidden"
      },
      body: {
        minHeight: "80vh"
      },
      inner: {
        height: "76vh"
      }
    };
  }

  render() {
    var styles = this.getStyles();

    return (
      <Dialog open={true} contentStyle={styles.dialog} bodyStyle={styles.body}>
        <div id="seatioInject" style={styles.inner} />
      </Dialog>
    );
  }
}

export default connectToStores(VenueSeatmapEditor);



// WEBPACK FOOTER //
// ./src/app/components/venue-seatmap-editor.jsx